<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';
    import idMixin from '@/mixins/aha-id';

    export default {
        mixins: [idMixin],
        provide() {
            return {
                EventBus: this.EventBus
            };
        },
        mounted() {
            var vm = this;

            this.EventBus.$on('stepTrigger', (index) => {
                // no index
                if(typeof index === 'undefined') {
                    this.goToNextStep();
                    // this.currentInput = null;
                } else {
                    this.goToStep(index);
                    // this.currentInput = null;
                }
            });

            // A different input can be registered per step
            this.EventBus.$on('registerInput', (stepKey, element) => {
                this.inputs[stepKey] = element;
                this.currentInput = this.inputs[stepKey];
            });
        },
        data() {
            return {
                EventBus: new Vue(),
                step: 1,
                inputs: {},
                currentInput: null
            }
        },
        methods: {
            goToNextStep() {
                const currentInput = this.inputs[this.step];

                this.step++;

                // window.scrollTo({ top: 200, behavior: 'smooth' });
                // console.log(this.step, 'go to next step', 'scroll to')

                // const el = document.querySelector('#main-content form[novalidate="novalidate"]');
                // const stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                // const headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                // const topPos = el.getBoundingClientRect().top + window.scrollY;
                // window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));

                // console.log('test out scroll to section', 0, topPos - (stickyHeight + headerUtilityHeight))

                this.EventBus.$emit('stepChanged', this.step, currentInput);
            },
            goToStep(index) {
                const currentInput = this.inputs[this.step];

                this.step = index;

                this.EventBus.$emit('stepChanged', this.step, currentInput);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-transition-group.vue